/**
 * Converts a string array to an array of options
 * @param options of type string[] to transform to an object
 */
export const createOptions = (options: string[] | undefined) => {
  if (options) {
    return options.map((o) => ({ value: o, label: o }));
  }
  return [];
};
